// @flow

import styled from "styled-components";

const RunnerItem = styled.div`
  width: auto;

  &:first-child {
    margin-left: 16px;
  }

  &:not(:first-child) {
    margin-left: 16px;
  }

  &:last-child {
    margin-right: 16px;
  }
`;

export default RunnerItem;
